<h3>{{ data.title | transloco }}</h3>
<p>{{ data.message | transloco }}</p>
